import {Button, Form, Modal} from "semantic-ui-react";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../app/hooks";
import {CreateNewLabelSize, UpdateLabelSize} from "./TablesActions";
import {ILabelSize} from "../../interfaces/ILabelSize";
import { RootState } from "../../app/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
interface ILabelSizeModal {
  open: boolean;
  row: any;
  updateRow: boolean;
  onClose: () => void;
}
export const LabelSizeModal = ({open, row, updateRow, onClose}: ILabelSizeModal) => {
  const [newRow, setNewRow] = useState<ILabelSize>({id: 0, name: "", width: undefined, height: undefined});
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<{[key: string]: string}>({});
  const {companyId} = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();

  useEffect(() => {
    if (updateRow) {
      setNewRow(row);
    } else {
      setNewRow({id: 0, name: "", width: undefined, height: undefined});
    }
  }, [row, updateRow]);

  const onInputChange = (e: any) => {
    const {name, value} = e.target;
    setErrors({...errors, [name]: ""});
    setNewRow({...newRow, [name]: value});
  };
  const validateForm = () => {
    let errors = {};

    // if (!/^\d+x\d+$/.test(newRow.id)) {
    //   errors = {...errors, id: "Id should be in the format of 'number x number'"};
    // }
    if (!newRow.width || !/^\d+$/.test(newRow.width.toString()) || Number(newRow.width) <= 0) {
      errors = {...errors, width: t("enter_valid_width")};
    }
    if (!newRow.height || !/^\d+$/.test(newRow.height.toString()) || Number(newRow.height) <= 0) {
      errors = {...errors, height: t("enter_valid_height")};
    }

    setErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const onSubmit = () => {
    if (validateForm()) {
      if (updateRow) {
        dispatch(UpdateLabelSize(newRow, companyId));
      } else {
        dispatch(CreateNewLabelSize(newRow, companyId));
      }
      onHide();
    }
  };
  const onHide = () => {
    setNewRow({id: 0, name: "", width: undefined, height: undefined});
    setErrors({});
    onClose();
  };
  return (
    <Modal size="small" closeIcon onClose={onHide} open={open}>
      <Modal.Header> {!updateRow ? t("create_labelsize") : t("update_labelsize")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          {/* <Form.Field required>
            <label>ID</label>
            <Form.Input placeholder={"0x0"} required name="id" value={newRow.id} onChange={onInputChange} disabled={updateRow} error={errors.id ? {content: errors.id, pointing: "below"} : false} />
          </Form.Field> */}
          <Form.Field required>
            <label>{t("name")}</label>
            <Form.Input autoFocus placeholder={t("name")} required name="name" value={newRow.name} onChange={onInputChange} error={errors.name ? {content: errors.name, pointing: "below"} : false} />
          </Form.Field>
          <Form.Group widths={"equal"}>
            <Form.Field required>
              <label>{t("width")}</label>
              <Form.Input placeholder={t("width")} required name="width" value={newRow.width || ""} onChange={onInputChange} error={errors.width ? {content: errors.width} : false} />
            </Form.Field>
            <Form.Field required>
              <label>{t("height")}</label>
              <Form.Input placeholder={t("height")} required name="height" value={newRow.height || ""} onChange={onInputChange} error={errors.height ? {content: errors.height} : false} />
            </Form.Field>
          </Form.Group>
          <button type="submit" style={{display: 'none'}} aria-hidden="true"></button>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
          {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onSubmit}>
          {!updateRow ? t("create_btn") : t("update_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
